/* Initialize after the deferred lazySizes dependency and before DOMContentLoaded. */
(function () {
  'use strict';
  window.lazySizes.init();
})();
